<template>
  <base-dropzone
    :id="id"
    v-model="files"
    class="file-selector"
    :accept="accept"
    :multiple="multiple"
    @invalid="$emit('invalid', $event)"
  >
    <label
      v-if="isEmpty"
      class="drag-drop-area d-flex flex-column"
      :style="dragDropAreaStyle"
      :for="id"
    >
      <slot name="label">
        <div
          class="flex-grow-1 d-flex flex-column justify-center align-center pa-3"
        >
          <v-icon
            color="#5bbaef"
            class="material-icons-outlined"
            size="34"
          >
            file_copy
          </v-icon>
          <div
            class="drag-drop-area-text text-body-2 font-weight-light pt-2"
          >
            <slot name="caption">
              <template v-if="multiple">
                Drag and drop your files or click here to browse
              </template>
              <template v-else>
                Drag and drop your file or click here to browse
              </template>
            </slot>
          </div>
        </div>
      </slot>
    </label>
    <slot></slot>
  </base-dropzone>
</template>

<script>
import { v4 as uuid } from 'uuid';
import BaseDropzone from './BaseDropzone';

export default {
  name: 'FileSelector',
  components: { BaseDropzone },
  props: {
    value: {
      type: [Array, File, Object],
      default: () => [],
    },
    accept: {
      type: Array,
      default: () => ['.ris'],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: 'rgba(245, 248, 255, 0.5)',
    },
    borderRadius: {
      type: String,
      default: '4px',
    },
    borderColor: {
      type: String,
      default: '#5bbaef',
    },
    id: {
      type: String,
      default: () => `file-selector-${uuid()}`,
    },
  },
  computed: {
    files: {
      get: function () {
        return this.value;
      },
      set: function (files) {
        this.$emit('input', files);
      },
    },
    isEmpty() {
      return this.multiple ? this.value.length === 0 : !this.value;
    },
    dragDropAreaStyle() {
      return {
        background: this.background,
        borderRadius: this.borderRadius,
        borderColor: `${this.borderColor}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.file-selector {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.drag-drop-area {
  flex-grow: 1;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 3px dashed;
}
.drag-drop-area:hover {
  border-color: var(--v-primary-base) !important;
  cursor: pointer;
}
.drag-drop-area:hover i {
  color: var(--v-primary-base) !important;
}
.drag-drop-area-text {
  color: #a7afbf;
}
label {
  cursor: pointer;
}
</style>
